export default __webpack_public_path__ + "static/media/labios-gruesos.a7c54a1c.png";